<template>
  <div>
    <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
					<li><a href="/">首頁</a></li>
					<li><a href="/news">忘記密碼</a></li>
					<li class="active">內容</li>
				</ol>
                <div class="row">
                    <div class="col-sm-2">
                        <div class="aside_menu">
                            <h4 class="title">會員查詢</h4>
                            <ul class="list-unstyled">
                                <li class="active item"><a href="">會員查詢</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-10">
                        <h4 class="text-center">忘記密碼</h4>
                        <div class="register_form">
                            <form class="form-horizontal">
                                <hr/>
                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">查詢密碼</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="email" placeholder="請輸入您的Email">
                                        (若當初填寫並未正確，請撥電話由公司進行變更。)
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9">
                                        <button type="button" class="btn btn-default" @click="findPassword()">查詢密碼</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Forgotpass',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      email: '',
      account: ''
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    findPassword () {
      let str = ''
      if (this.email === '') {
        str += '請輸入您的Email，我們將預設為您的『大寫身份證字號』。\n'
      }
      if (str === '') {
        this.$http.post(this.apiurl + 'api/getPassword', {
          email: this.email
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          let data = res.body.data
          let status = data.status
          if (status === 200) {
            window.alert('查詢成功，您的密碼已預設為身份證字號。')
          } else {
            window.alert('查詢失敗')
          }
        }, function () {
          console.log('failed')
        })
      } else {
        window.alert(str)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Forgotpass.vue?08c32faa